import React from 'react';
import Layout from '../Components/Layout';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Card, CardContent, Typography, Stack, Chip, IconButton, Tooltip, Button, Grid, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, TextField, InputAdornment, IconButton as MIconButton } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';
import { useState } from 'react';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useForm } from 'react-hook-form';
import { changePassword } from '../redux/actions/authActions';

function BasicSetup() {
  const user = useSelector((state) => state?.auth?.user);
  const { changePasswordLoading } = useSelector((state) => state?.auth);
  const dispatch = useDispatch();
  const [copied, setCopied] = useState(false);
  const { register, handleSubmit, watch, formState: { errors }, reset } = useForm();
  const [showOld, setShowOld] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);

  const handleChangePassword = async () => {
    try {
      const values = {
        oldPassword: watch('oldPassword'),
        newPassword: watch('newPassword'),
      };
      await dispatch(changePassword(values.oldPassword, values.newPassword));
      reset();
    } catch (_) {}
    setConfirmOpen(false);
  };

  const handleCopy = async () => {
    if (!user?.email) return;
    try {
      await navigator.clipboard.writeText(user.email);
      setCopied(true);
      setTimeout(() => setCopied(false), 1200);
    } catch (_) {}
  };

  const handlePrivacyPolicyClick = () => {
    window.open('/privacy-policy', '_blank');
  };

  const handleTermsAndConditionsClick = () => {
    window.open('/terms-and-conditions', '_blank');
  };

  return (
    <Layout>
      <Box sx={{mt: 3, px: 2 }}>
      <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
          Basic Setup
        </Typography>
         <Grid container spacing={2} sx={{ alignItems: 'stretch' }}>
         <Grid size={{ xs: 12, lg: 6 }} sx={{ height: '100%' }}>
        

        {/* Account Card */}
        <Card elevation={3} sx={{ borderRadius: 2, mb: 3 }}>
          <CardContent>
            {/* <Typography variant="subtitle2" color="text.secondary" gutterBottom>
              Account
            </Typography> */}
            <Stack spacing={1.5}>
              <Stack direction="row" alignItems="center" justifyContent="space-between">
                <Typography variant="body2" color="text.secondary">Brand Name</Typography>
                <Chip label={user?.company || '—'}  variant="outlined" sx={{ fontWeight: 600 }} />
              </Stack>

              <Stack direction="row" alignItems="center" justifyContent="space-between">
                <Typography variant="body2" color="text.secondary">Email</Typography>
                {/* <Stack direction="row" alignItems="center" spacing={1}> */}
                  <Chip label={user?.email || '—'} variant="outlined" sx={{ fontWeight: 600 }} />
                  {/* <Tooltip title={copied ? 'Copied' : 'Copy'}>
                    <IconButton size="small" onClick={handleCopy} aria-label="copy-email">
                      {copied ? <CheckIcon fontSize="small" /> : <ContentCopyIcon fontSize="small" />}
                    </IconButton>
                  </Tooltip> */}
                {/* </Stack> */}
              </Stack>
            </Stack>
          </CardContent>
        </Card>

        {/* Privacy Policy Box */}
        <Box 
          sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'space-between',
            p: 3,
            bgcolor: 'white',
            borderRadius: 2,
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
            border: '1px solid #e5e7eb',
            mb: 3
          }}
        >
          <Typography 
            variant="body1" 
            sx={{ 
              color: '#374151', 
              fontWeight: 500 
            }}
          >
            Privacy Policy
          </Typography>
          
          <Button
            variant="contained"
            onClick={handlePrivacyPolicyClick}
            sx={{
              bgcolor: '#000',
              color: 'white',
              borderRadius: 2,
              px: 3,
              py: 1,
              textTransform: 'none',
              fontWeight: 500,
              '&:hover': {
                bgcolor: '#333'
              }
            }}
          >
            View
          </Button>
        </Box>

        {/* Terms and Conditions Box */}
        <Box 
          sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'space-between',
            p: 3,
            bgcolor: 'white',
            borderRadius: 2,
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
            border: '1px solid #e5e7eb'
          }}
        >
          <Typography 
            variant="body1" 
            sx={{ 
              color: '#374151', 
              fontWeight: 500 
            }}
          >
            Terms & Conditions
          </Typography>
          
          <Button
            variant="contained"
            onClick={handleTermsAndConditionsClick}
            sx={{
              bgcolor: '#000',
              color: 'white',
              borderRadius: 2,
              px: 3,
              py: 1,
              textTransform: 'none',
              fontWeight: 500,
              '&:hover': {
                bgcolor: '#333'
              }
            }}
          >
            View
          </Button>
        </Box>  
        </Grid>
        {/* Forgot Password */}
        <Grid size={{ xs: 12, lg: 6 }} sx={{ height: '100%', display: 'flex' }}>
          <Card elevation={3} sx={{ borderRadius: 2, height: '100%', width: '100%', display: 'flex' }}>
            <CardContent sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
              <Typography variant="h6" sx={{ fontWeight: 700, mb: 3 }}>Change Password</Typography>
              <form onSubmit={handleSubmit(() => setConfirmOpen(true))} noValidate>
                <Stack spacing={2}>
                  <TextField
                    label="Enter Current Password"
                    fullWidth
                    type={showOld ? 'text' : 'password'}
                    size="small"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <MIconButton onClick={() => setShowOld(v => !v)} edge="end" size="small">
                            {showOld ? <VisibilityOff /> : <Visibility />}
                          </MIconButton>
                        </InputAdornment>
                      )
                    }}
                    {...register('oldPassword', { required: 'Old password is required' })}
                    error={!!errors.oldPassword}
                    helperText={errors.oldPassword?.message || ''}
                    sx={{
                      marginBottom: "10px !important"
                    }}
                  />

                  <TextField
                    label="Enter New Password"
                    fullWidth
                    type={showNew ? 'text' : 'password'}
                    size="small"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <MIconButton onClick={() => setShowNew(v => !v)} edge="end" size="small">
                            {showNew ? <VisibilityOff /> : <Visibility />}
                          </MIconButton>
                        </InputAdornment>
                      )
                    }}
                    {...register('newPassword', {
                      required: 'New password is required',
                      minLength: { value: 6, message: 'Password must be at least 6 characters long' }
                    })}
                    error={!!errors.newPassword}
                    helperText={errors.newPassword?.message || ''}
                    sx={{
                      marginBottom: "10px !important"
                    }}
                    
                  />

                  <TextField
                    label="Confirm Password"
                    fullWidth
                    type={showConfirm ? 'text' : 'password'}
                    size="small"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <MIconButton onClick={() => setShowConfirm(v => !v)} edge="end" size="small">
                            {showConfirm ? <VisibilityOff /> : <Visibility />}
                          </MIconButton>
                        </InputAdornment>
                      )
                    }}
                    {...register('confirmPassword', {
                      required: 'Confirm password is required',
                      validate: (val) => val === watch('newPassword') || 'Passwords do not match'
                    })}
                    error={!!errors.confirmPassword}
                    helperText={errors.confirmPassword?.message || ''}
                    sx={{
                      marginBottom: "10px !important"
                    }}
                  />

                  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button type="submit" variant="contained" sx={{ bgcolor: '#000', color: '#fff', borderRadius: 2, textTransform: 'none', fontWeight: 600, width: 120 }} disabled={changePasswordLoading}>
                      {changePasswordLoading ? 'Saving...' : 'Save'}
                    </Button>
                  </Box>
                </Stack>
              </form>
            </CardContent>
          </Card>
          <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
            <DialogTitle>Confirm Change</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Are you sure you want to change your password?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setConfirmOpen(false)}>Cancel</Button>
              <Button onClick={handleChangePassword} variant="contained" disabled={changePasswordLoading}>Confirm</Button>
            </DialogActions>
          </Dialog>
        </Grid>
        </Grid>
      </Box>
    </Layout>
  );
}

export default BasicSetup;
